import { Event } from "../events/Event";
import { EventDispatcher } from "../events/EventDispatcher";
import { PAL } from "../platform/PlatformAdapters";
import { Byte } from "../utils/Byte";
import { getErrorMsg } from "../utils/Error";
export class Socket extends EventDispatcher {
    constructor(host, port, byteClass, protocols, isSecure) {
        super();
        this.disableInput = false;
        if (Array.isArray(byteClass))
            protocols = byteClass;
        if (typeof (protocols) === "boolean") {
            isSecure = protocols;
            protocols = null;
        }
        this.output = new Byte();
        this.input = new Byte();
        this.endian = Byte.BIG_ENDIAN;
        if (host && port > 0 && port < 65535)
            this.connect(host, port, isSecure, protocols);
    }
    get connected() {
        return this._connected;
    }
    get endian() {
        return this.output.endian;
    }
    set endian(value) {
        this.input.endian = value;
        this.output.endian = value;
    }
    connect(host, port, isSecure, options) {
        this.connectByUrl(`${isSecure ? "wss" : "ws"}://${host}:${port}`, options);
    }
    connectByUrl(url, options) {
        if (this._socket != null)
            this.close();
        this.output.length = 0;
        this.input.length = 0;
        this._inputPos = 0;
        if (Array.isArray(options)) {
            options = { protocols: options };
        }
        this._socket = PAL.browser.createWebSocket();
        if (this._socket == null) {
            console.warn("WebSocket is not supported in this platform.");
            return;
        }
        this._socket.onOpen = () => {
            this._connected = true;
            this.event(Event.OPEN);
        };
        this._socket.onClose = () => {
            this._connected = false;
            this.event(Event.CLOSE);
        };
        this._socket.onError = (e) => {
            if (this.hasListener(Event.ERROR))
                this.event(Event.ERROR, e);
            else
                console.error("Socket Error: " + getErrorMsg(e));
        };
        this._socket.onMessage = (msg) => this._onMessage(msg);
        this._socket.open(url, options);
    }
    close() {
        if (this._socket != null) {
            try {
                this._socket.close();
            }
            catch (e) {
            }
            this._socket = null;
        }
        this._connected = false;
    }
    cleanSocket() {
        this.close();
    }
    send(data) {
        return this._socket.send(data);
    }
    flush() {
        if (this.output.length === 0 || !this._socket || !this._connected)
            return;
        let err;
        try {
            this._socket.send(this.output.rawBuffer.slice(0, this.output.length));
        }
        catch (e) {
            err = e;
        }
        this.output.clear();
        if (err)
            this.event(Event.ERROR, err);
    }
    _onMessage(data) {
        if (this.disableInput) {
            this.event(Event.MESSAGE, data);
            return;
        }
        if (this.input.length > 0 && this.input.bytesAvailable < 1) {
            this.input.clear();
            this._inputPos = 0;
        }
        let pre = this.input.pos;
        !this._inputPos && (this._inputPos = 0);
        this.input.pos = this._inputPos;
        if (typeof (data) == 'string') {
            this.input.writeUTFBytes(data);
        }
        else {
            this.input.writeArrayBuffer(data);
        }
        this._inputPos = this.input.pos;
        this.input.pos = pre;
        this.event(Event.MESSAGE, data);
    }
}
